import React from 'react';
import '../styles/components/news.scss';

function NewsAnnouncements() {

  const newsData = [
    { date: '15 Jan 2026', text: 'NCVPRIPG 2026 website is live.' },
    { date: '01 Feb 2026', text: 'Call for Papers has been announced.' },
    { date: '10 Mar 2026', text: 'Submission portal will open soon.' },
    { date: '25 Mar 2026', text: 'Important dates updated.' }
  ];

  return (
    <section id="news" className="news-section section-padding">
      <div className="container">
        <h2 className="section-title">News & Announcements</h2>

        <div className="news-card">
          <div className="news-ticker">
            <ul className="news-list">
              {newsData.map((item, index) => (
                <li key={index}>
                  <span className="news-date">{item.date}</span>
                  <span className="news-text">{item.text}</span>
                </li>
              ))}

              {/* duplicate for infinite scroll */}
              {newsData.map((item, index) => (
                <li key={`dup-${index}`}>
                  <span className="news-date">{item.date}</span>
                  <span className="news-text">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsAnnouncements;
